var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer"},[_vm._v(" Thai Samsung Electronics Co,.Ltd. All Right Reserved. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }